import React, { useState, createContext, useContext } from "react";
import { Cookies, getCookieConsentValue } from "react-cookie-consent";
import parse from "html-react-parser";

import { languageOptions, dictionaryList } from "../languages";

// create the language context with default selected language
export const LanguageContext = createContext({
    userLanguage: "en",
    dictionary: dictionaryList.en,
});

// it provides the language context to app
export function LanguageProvider({ children }) {
    const [userLanguage, setUserLanguage] = useState("en");

    const provider = {
        userLanguage,
        dictionary: dictionaryList[userLanguage],
        userLanguageChange: (selected) => {
            const newLanguage = languageOptions[selected] ? selected : "en";
            setUserLanguage(newLanguage);

            Window.myLanguageCache = newLanguage; // Save a memory cache value

            // Register the cookie if possible
            if (getCookieConsentValue()) {
                Cookies.set("language", newLanguage, { path: "/" });
            }
        },
    };

    // Returns our provider
    return (
        <LanguageContext.Provider value={provider}>
            {children}
        </LanguageContext.Provider>
    );
}

// get text according to id & current language
export function Text({ tid, html }) {
    const languageContext = useContext(LanguageContext);

    const text = languageContext.dictionary[tid] || tid;

    return html ? parse(text) : text;
}
